// auth.js
const AUTH_KEY = "userLoggedin";

export const isAuthenticated = () => {
  const data = JSON.parse(localStorage.getItem(AUTH_KEY));
  return data?.userId && data?.password;
};

export const login = (login, password, lastLogin) => {
  localStorage.setItem(AUTH_KEY, JSON.stringify({ login, password }));
};

export const logout = () => {
  console.log("Logging out...");

  // Remove authentication key if you are using one
  localStorage.removeItem(AUTH_KEY);
};
